import { createRouter, createWebHistory } from "vue-router";
// import store from '../store';
const routes = [
  {
    path: "/",
    name: "Dashboard",
    meta: {
      requiresAuth: true,
    },
    component: () => import("../layouts/AdminLayout.vue"),
    // component: !store.state.isLoading ?
    //   () => import('../layouts/DefaultLayout.vue') :
    //   () => import('../layouts/AdminLayout.vue'),
    // component: () => import(`../layouts/${store.state.isLoading ? 'DefaultLayout.vue' : 'AdminLayout.vue' }`),
    children: [
      {
        path: "/",
        component: () => import("../views/company/Company.vue"),
      },
      {
        path: "/users",
        component: () => import("../views/user/User.vue"),
      },
      {
        path: "/carousel",
        component: () => import("../views/carousel/Carousel.vue"),
      },
      {
        path: "/carousel/:id",
        component: () => import("../views/carousel/DetailCarousel.vue"),
      },
      {
        path: "/tenant-category",
        component: () => import("../views/tenant/TenantCategory.vue"),
      },
      {
        path: "/tenant",
        component: () => import("../views/tenant/Tenant.vue"),
      },
      {
        path: "/tenant/:id",
        name: "TenantDetail",
        component: () => import("../views/tenant/TenantDetail.vue"),
      },
      {
        path: "/promo-category",
        component: () => import("../views/promo/PromoCategory.vue"),
      },
      {
        path: "/promo",
        component: () => import("../views/promo/Promo.vue"),
      },
      {
        path: "/destination",
        component: () => import("../views/destination/Destination.vue"),
      },
      {
        path: "/destination/:id",
        component: () => import("../views/destination/DestinationDetail.vue"),
      },
      {
        path: "/destinationpremium",
        component: () => import("../views/destination/DestinationPremium.vue"),
      },
      {
        path: "/promo/:id",
        component: () => import("../views/promo/PromoDetail.vue"),
      },
      {
        path: "/sosmed",
        component: () => import("../views/sosmed/Sosmed.vue"),
      },
      {
        path: "/event",
        component: () => import("../views/event/Event.vue"),
      },
      {
        path: "/event/videoEvent/:id",
        component: () => import("../views/event/VideoEventDetail.vue"),
      },
      {
        path: "/event-premium",
        component: () => import("../views/event/EventPremium.vue"),
      },
      {
        path: "/event/:id",
        component: () => import("../views/event/EventDetail.vue"),
      },
      {
        path: "/faciliti",
        component: () => import("../views/faciliti/Faciliti.vue"),
      },
      {
        path: "/subscriber",
        component: () => import("../views/subscriber/Subscriber.vue"),
      },
      {
        path: "/floor",
        component: () => import("../views/floor/Floor.vue"),
      },
      {
        path: "/information",
        component: () => import("../views/information/Information.vue"),
      },
      {
        path: "/information/promo/:id",
        component: () =>
          import("../views/information/InformationPromoDetail.vue"),
      },
      {
        path: "/information/event/:id",
        component: () =>
          import("../views/information/InformationEventDetail.vue"),
      },
      {
        path: "/information/destination/:id",
        component: () =>
          import("../views/information/InformationDestinationDetail.vue"),
      },
      {
        path: "/profile",
        component: () => import("../views/profile/Profile.vue"),
      },
      {
        path: "/seo",
        component: () => import("../views/seo/Seo.vue"),
      },
      {
        path: "/experience",
        component: () => import("../views/experience/Experience.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // console.log(store.state);
  // localStorage.removeItem('token', localStorage)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("access_token") === null) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      next({
        name: "Login",
      });
      return;
    } else {
      next();
      //     try {
      //       let res = await fetch('https://api.23paskal.fiture.id/v1/refresh', {
      //         method: 'POST',
      //         headers: {
      //           "Content-Type": "application/json",
      //         },
      //         body: JSON.stringify({
      //           refresh_token: localStorage.getItem('refresh_token'),
      //         }),
      //       });
      //       let respon = await res.json();
      //       if (respon.status !== 200) {
      //         localStorage.removeItem('access_token')
      //         localStorage.removeItem('refresh_token')
      //         next({
      //           name: 'Login',
      //         })
      //         return
      //       }
      //       localStorage.setItem('access_token', respon.data.access_token)
      //       localStorage.setItem('refresh_token', respon.data.refresh_token)
      //       next()
      //     } catch (err) {
      // localStorage.removeItem('access_token')
      //       localStorage.removeItem('refresh_token')
      //       next({
      //         name: 'Login',
      //       })
      //     }
    }
  } else {
    next();
  }
});

export default router;
